import { Fragment } from 'react';

const linkSplit = (text) => text.split(/\[([^\]]+)\]\(([^)]+)\)/);

const renderLinks = (text, keyPrefix) => {
  const parts = linkSplit(text);
  if (parts.length === 1) return text;
  const nodes = [];
  for (let i = 0; i < parts.length; i += 3) {
    if (parts[i]) nodes.push(parts[i]);
    if (parts[i + 1] !== undefined) {
      nodes.push(
        <a key={`${keyPrefix}-${i}`} href={parts[i + 2]} target="_blank" rel="noopener noreferrer" className="bio-link">
          {parts[i + 1]}
        </a>
      );
    }
  }
  return nodes;
};

// Lightweight inline-markdown renderer: **bold** -> <strong>, [text](url) -> an external
// link (always target="_blank"/rel="noopener noreferrer", styled via the shared .bio-link
// class). One authoring convention for inline emphasis/links, shared by CaseStudy's `text`
// and `two-col-text` sections and Home's bio paragraphs — those three call sites used to each
// do this differently (markdown-bold via a CaseStudy-local renderInline, raw <strong> HTML via
// dangerouslySetInnerHTML, and raw <a> HTML via dangerouslySetInnerHTML, respectively).
export const renderInline = (text) => {
  const parts = text.split(/\*\*(.*?)\*\*/);
  if (parts.length === 1) return renderLinks(text, 'link');
  return parts.map((part, i) =>
    i % 2 === 1
      ? <strong key={`bold-${i}`}>{part}</strong>
      : <Fragment key={`frag-${i}`}>{renderLinks(part, `link-${i}`)}</Fragment>
  );
};
